// Simple widget registry to enable external extension without editing core files
// Consumers can register new chart/stat types at app startup.

const chartRegistry = Object.create(null);
const statRegistry = Object.create(null);
const iconRegistry = Object.create(null);

export function registerChartType(type, Component) {
    if (!type || typeof Component !== 'function') return;
    chartRegistry[String(type)] = Component;
}

export function registerStatType(type, Component) {
    if (!type || typeof Component !== 'function') return;
    statRegistry[String(type)] = Component;
}

export function registerIcon(name, src) {
    if (!name) return;
    iconRegistry[String(name)] = src;
}

export function getChartComponent(type) {
    return chartRegistry[String(type)];
}

export function getStatComponent(type) {
    return statRegistry[String(type)];
}

export function getIcon(name) {
    return iconRegistry[String(name)];
}

export function listChartTypes() {
    return Object.keys(chartRegistry);
}

export function listStatTypes() {
    return Object.keys(statRegistry);
}

// Pre-register built-ins so existing behavior remains unchanged
export function bootstrapDefaultWidgets() {
    try {
        const { default: BarChart } = require('./Charts/BarChart');
        const { default: StackedBarChart } = require('./Charts/StackedBarChart');
        const { default: SideBySideBarChart } = require('./Charts/SideBySideBarChart');
        const { default: BarInBarChart } = require('./Charts/BarInBarChart');
        const { default: LineChart } = require('./Charts/LineChart');
        const { default: SemiGaugeChart } = require('./Charts/SemiGaugeChart');
        const { default: DonutChart } = require('./Charts/DonutChart');

        registerChartType('bar-chart', BarChart);
        registerChartType('stacked-bar-chart', StackedBarChart);
        registerChartType('side-by-side-bar-chart', SideBySideBarChart);
        registerChartType('bar-in-bar-chart', BarInBarChart);
        registerChartType('line-chart', LineChart);
        registerChartType('semi-gauge-chart', SemiGaugeChart);
        registerChartType('donut-chart', DonutChart);
    } catch (_) {
        // noop in test/storybook environments
    }

    try {
        const { default: BasicStatCard } = require('./Stats/BasicStatCard');
        const { default: ProgressStatCard } = require('./Stats/ProgressStatCard');
        const { default: GridStatCard } = require('./Stats/GridStatCard');
        const { default: ChartListStatCard } = require('./Stats/ChartListStatCard');

        registerStatType('basic-stat-card', BasicStatCard);
        registerStatType('progress-stat-card', ProgressStatCard);
        registerStatType('grid-stat-card', GridStatCard);
        registerStatType('chart-list-stat-card', ChartListStatCard);
    } catch (_) {
        // noop
    }

    try {
        // Icons used by stats
        const DollarIcon = require('images/dashboard/dollar-icon.svg');
        const UserIcon = require('images/dashboard/user-icon.svg');
        registerIcon('dollar', DollarIcon?.default || DollarIcon);
        registerIcon('user', UserIcon?.default || UserIcon);
    } catch (_) {
        // noop
    }
}

// Initialize defaults immediately on import
bootstrapDefaultWidgets();

export default {
    registerChartType,
    registerStatType,
    registerIcon,
    getChartComponent,
    getStatComponent,
    getIcon,
    listChartTypes,
    listStatTypes,
};


